import(/* webpackMode: "eager" */ "/builds/magic.ai/frontend/magicsquare/apps/launchpad/components/pages/HowItWorks/Page.tsx")